import { JSX, useContext, useEffect } from "react";
import { AuthContext, IAuthContext } from "react-oauth2-code-pkce";
import { useLogoutMutation } from "../../../app/rootReducer";

export const LogOutRequest = (): JSX.Element => {
    const { logOut, logIn } = useContext<IAuthContext>(AuthContext);
    const [postLogout] = useLogoutMutation();

    useEffect(() => {
        const handleLogout = async (): Promise<void> => {
            try {
                await postLogout();
                localStorage.clear();
            } catch (error) {
                console.error("Logout failed:", error);
            }
        };

        handleLogout().then(() => {
            logIn("after-logout", { prompt: "login" });
        });
    }, [logIn, logOut, postLogout]);

    return <div>Logging out...</div>;
};
